import 'css-chunksrc/client/scenes/comments/styles.scss';export default {
  "comments": "_comments_1q4m0_1",
  "feed": "_feed_1q4m0_8",
  "form": "_form_1q4m0_15"
};